import apiBackground from "../apiBackground";

const getComprobantes = async (params) => {
  const endpoint = "/administracion/comprobantes";
  const { data } = await apiBackground.get(endpoint, { params });

  return data;
};

const generarCertificacion = async (params) => {
  const endpoint = "/administracion/generar-certificacion";
  const { data } = await apiBackground.get(endpoint, { params });

  return data;
};

const generarReporte = async (params) => {
  const endpoint = "/administracion/archivo-reporte-rendicion-mensual";
  const { data } = await apiBackground.get(endpoint, { params });

  return data;
};

const descargarComprobante = async (params) => {
  const endpoint = "/administracion/archivo-comprobante-retencion";
  const { data } = await apiBackground.get(endpoint, { params });

  return data;
};

const liquidarRetenciones = async (params) => {
  const endpoint = "/reporte/liquidar-retenciones";
  const { data } = await apiBackground.get(endpoint, { params });

  return data;
};

export default {
  getComprobantes,
  generarCertificacion,
  generarReporte,
  descargarComprobante,
  liquidarRetenciones,
};
